import React, { useMemo, useState, useRef } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  Bar
} from 'recharts';
import Slider from 'react-slick';
import { useLocation } from 'react-router-dom';

const slick = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 6000,
};

const TheCharts = ({ cStudy }) => {
  return useMemo(() => {
    if (!cStudy.length) {
      return (
        <div style={{ display: 'table', width: '100%', height: 398 }}>
          <div style={{
            display: 'table-cell', verticalAlign: 'middle', textAlign: 'center'
          }}>
            <div className="lds-dual-ring2" />
          </div>
        </div>
      )
    }

    return (
      <Slider {...slick}>
        <div>
          <h6>Number of studies in 5 years interval </h6>
          <ResponsiveContainer id="chart-projects" width="100%" height={320}>
            <BarChart
              width="100%"
              height={320}
              data={cStudy}
              margin={{ top: 5, right: 0, bottom: 5, left: -35 }}
              maxBarSize={20}
            >
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <CartesianGrid stroke="#e3e3e3" />

              <Bar dataKey="Harvest" fill="#3c8e7c" stackId="a" />
              <Bar dataKey="Market" fill="#979332" stackId="a" />
              <Bar dataKey="Consumption" fill="#d39600" stackId="a" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Slider>
    )
  }, [cStudy])
}

const Charts = ({ cStudy }) => {
  const location = useLocation();
  const [show, setShow] = useState(true);
  const chartRef = useRef();

  if (location.pathname !== '/') {
    return null;
  }

  return (
    <>
      <div
        ref={chartRef}
        style={{
          display: show ? '' : 'none',
          zIndex: show ? 1 : -10
        }}
      >
        <TheCharts cStudy={cStudy} />
        <hr />
      </div>
      <small
        rel="presentation"
        style={{
          float:'right',
          marginTop: -15,
          fontWeight: 500,
          color: '#3b8e7c',
          cursor: 'pointer'
        }}
        onClick={() => {
          chartRef.current.style.opacity = 0;
          if (!show) {
            setTimeout(() => {
              chartRef.current.style.opacity = 1;
            }, 250);
          }
          setShow(!show);
        }}
      >
        {show ? 'Hide' : 'Show'} chart
      </small>
    </>
  )

}
export default Charts
